module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT7_sc_.6c345368.eot";